import axios from "api";

export const gettranscript = (id) => {
  // const a = id.toString();
  return axios.get(`call-logs/conversation/get/?uuid=${id}`);
};
